module.exports = __webpack_public_path__ + "img/member_empty.1e873344.png";